<template>
  <div class="APIHomepage DataLibraryIndex">
    <div class="title">Website Navigation</div>
    <div class="contentlist-box">
      <el-checkbox-group v-model="apicheckList" class="api-checkbox-group">
        <div
          class="api-modules"
          v-for="(item, index) in apiDataDocumentationList"
          :key="index"
          @click="handleCardClick(item)"
        >
          <div class="api-topbox">
            <div class="api-leftbox">
              <el-checkbox
                class="api-checkbox"
                :label="item.id"
                @click.native.stop
                v-show="TesRecordsPageData.isShowCheckBtn_WebN"
              ></el-checkbox>
              <div class="api-title">{{ item.apiName }}</div>
            </div>
            <div class="api-tag">
              <!-- <el-tag
                v-for="(i, idx) in labelList"
                :key="idx"
                class="flex_center_start tag"
                :type="idx == 0 ? 'warning' : ''"
              >
                <img
                  v-if="idx == 0"
                  src="@/assets/images/dataServices/dataLibrary-img/tag.png"
                  alt=""
                />
                {{ i.labelName }}
              </el-tag> -->
              <el-tag
                v-for="(i, idx) in item.apiLabels"
                :key="idx"
                :class="'COLOR_' + i.labelColor"
              >
                {{ i.labelName }}
              </el-tag>
            </div>
          </div>
          <div class="api-desc">
            {{ item.apiDescription || "--" }}
          </div>
          <div class="api-date-footer">
            <div class="api-date-version flex_center_bettwen">
              <div>
                Updated on
                {{ $formatDateTime(item.updateTime, "yyyy-MM-dd hh:mm:ss") }}
              </div>
              <div>Version: v2.1</div>
            </div>
            <div class="api-download-box">
              <el-button
                type="primary"
                class="api-apply-btn"
                @click.stop="DownloadnClick(item)"
              >
                <div class="flex_center">
                  <img
                    class="api-apply-btn-img"
                    src="@/assets/images/dataServices/dataLibrary-img/icon4.png"
                    alt=""
                  />
                  Download
                </div>
              </el-button>
            </div>
          </div>
        </div>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
import {
  getApiDataApiPage,
  downLoadFileByItemId,
  getApiDataApiItemById,
} from "@/api/dataServicesApi";
import { downloadFromBase64 } from "@/utils/date";
export default {
  name: "WebsiteNavigation",
  props: {
    scrollContainer: {
      type: Element,
      default: null,
    },
    TesRecordsPageData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      apiDataDocumentationList: [],
      labelList: [
        //暂时显示 数据未定
        { labelName: "REST API" },
        { labelName: "Batch Processing" },
        { labelName: "JSON" },
      ],
      apicheckList: [], // 存储已选中的 ID
      page: {
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      loading: false, // 👈 新增：是否正在加载
      noMore: false,
    };
  },
  components: {},
  computed: {},
  watch: {
    // 当父组件传入 scrollContainer 后再绑定事件
    scrollContainer: {
      handler(newVal) {
        if (newVal) {
          // 防止重复绑定
          if (this._hasBoundScroll) return;
          this.getApiDataApiPageList(); // 首次加载
          newVal.addEventListener("scroll", this.handleScroll);
          this._hasBoundScroll = true; // 标记已绑定
        }
      },
      immediate: true,
    },
    TesRecordsPageData: {
      handler(newVal) {
        // 检查目标属性是否变化
        if (newVal && newVal.isReselectCheckBtn_WebN) {
          // 如果点击了reselect工具按钮 isReselectCheckBtn_WebN为true 则重置选中的多选框
          if (this.apicheckList == []) return;
          this.apicheckList = [];
        }
      },
      deep: true, // 必须开启深度监听
      immediate: true, // 如果需要初始化时也执行一次
    },
    apicheckList: {
      handler(newVal) {
        // 检查目标属性是否变化
        if (newVal) {
          // 触发事件，把数据发给父组件
          this.$emit("update-selection", newVal, "2");
        }
      },
      deep: true, // 必须开启深度监听
      // immediate: true // 如果需要初始化时也执行一次
    },
  },
  created() {},
  mounted() {},
  beforeDestroy() {
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener("scroll", this.handleScroll);
    }
    this._hasBoundScroll = false; // 清理标记
  },
  methods: {
    // 外层 div 点击
    handleCardClick(item) {
      this.$router.push({
        path: "websiteNavigationDetail",
        query: {
          id: item.id,
        },
      });
    },
    // 滚动页面 加载数据
    handleScroll() {
      const el = this.scrollContainer;
      if (!el || this.loading || this.noMore) return; // 👈 关键：加锁 + 无更多数据时退出
      const scrollTop = el.scrollTop;
      const clientHeight = el.clientHeight;
      const scrollHeight = el.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        this.getApiDataApiPageList();
      }
    },
    // 获取二级分类
    async getApiDataApiPageList() {
      // 双重保险：方法入口也检查
      if (this.loading || this.noMore) return;
      this.loading = true; // 上锁
      try {
        let params = {
          apiDisplayType: 3,
          page: this.page.pageNo,
          pageSize: this.page.pageSize,
        };
        let res = await getApiDataApiPage(params);
        if (res.code == 200) {
          let newData = JSON.parse(JSON.stringify(res.data.rows));
          // 合并数据
          this.apiDataDocumentationList = [
            ...this.apiDataDocumentationList,
            ...newData,
          ];

          // 判断是否还有更多 当前条数不满10条说明 没数据了
          if (newData.length < this.page.pageSize) {
            this.noMore = true;
          } else {
            this.page.pageNo++;
          }
          this.page.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.error("分页加载失败:", error);
        this.$message.error("加载失败，请重试");
      } finally {
        this.loading = false; // 👈 释放锁（无论成功失败）
      }
    },
    // 下载pdf
    async DownloadnClick(row) {
      // 先获取详情拿到id
      let res1 = await getApiDataApiItemById(`?id=${row.id}`);
      if (res1.code != 200) {
        this.$message.error(res1.msg);
        return;
      }
      this.apiInfo = JSON.parse(JSON.stringify(res1.data));
      let params = {
        apiItemId: this.apiInfo.id,
        fileType: "pdf",
      };
      downLoadFileByItemId(params).then((res) => {
        if (res.code == 200) {
          // 截取文件后缀名 查看属于什么文件
          let fileType = res.msg.split(".").pop().toLowerCase();
          var downloadType = "";
          if (fileType == "pdf") {
            downloadType = "application/pdf";
          }
          console.log("下载", downloadType);
          downloadFromBase64(res.data, downloadType, res.msg);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
@import "../../../assets/css/DataLibraryIndexpage.css";
</style>
